import { render, staticRenderFns } from "./Page403.vue?vue&type=template&id=27525b95&scoped=true&"
import script from "./Page403.vue?vue&type=script&lang=js&"
export * from "./Page403.vue?vue&type=script&lang=js&"
import style0 from "./Page403.vue?vue&type=style&index=0&id=27525b95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27525b95",
  null
  
)

export default component.exports